// extracted by mini-css-extract-plugin
export var cardTitle = "_h9-1";
export var commentBubble = "_h9-e";
export var commentForm = "_h9-a";
export var commentInput = "_h9-b";
export var commentLabel = "_h9-d";
export var commentPrompt = "_h9-9";
export var csatCard = "_h9-0";
export var feedbackSection = "_h9-7";
export var starDisabled = "_h9-6";
export var starEmpty = "_h9-5";
export var starFilled = "_h9-4";
export var starWrapper = "_h9-3";
export var starsContainer = "_h9-2";
export var submittedComment = "_h9-c";
export var thankYouText = "_h9-8";